<template>
    <div v-wechat-title="title">
        <crud-facecade
            :showSequence="false"
            ref="room_settings"
            :url="url"
            :tableHeight="tableHeight"
            :columns="columnList"
            :fuzzySearch="false"
            :columnConfig="true"
            :buttons="[]"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            @loadCheckList="loadCheckList"
        >
            <slot slot="filter">
                <el-col :md="8" :xl="4" class="align-left">
                    <item-input type="datearraw2" v-model="scheduling_date"></item-input>
                </el-col>
                <el-col :md="6" :xl="4" class="padding-right10">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="syncWorkerToScheduledSurgery">分配手术人员</el-button>
                <el-button type="primary" size="mini" @click="copy">复制</el-button>
            </template>
        </crud-facecade>
        <cus-dialog :title="docinfo.title" :visible.sync="dialogFormVisible" :footerVisible="false" width="60%" class="dialog-adverse">
            <el-row>
                <el-col :span="24" class="align-right">
                    <label style="line-height: 35px">核对人：</label>
                    <item-input
                        class="block-multi-collapse-select-width"
                        :collapseTags="true"
                        style="width: 180px"
                        type="select"
                        v-model="active_item.check_user_id"
                        :options="this.roomssettingWorkers[`护士`]"
                        placeholder="核对人"
                    ></item-input>
                    <label style="padding-left: 30px; line-height: 35px">记录时间:</label>
                    <item-input
                        style="width: 180px"
                        :collapseTags="true"
                        :noPadding="true"
                        datetimeFormate="yyyy/MM/dd HH:mm"
                        type="datetime"
                        v-model="active_item.check_date"
                        placeholder="记录时间"
                    ></item-input>
                    <span style="padding-left: 30px">
                        <el-button type="primary" size="mini" plain @click="SaveChanges('合格')" style="margin-left: unset !important">核对通过</el-button>
                        <el-button type="primary" size="mini" plain @click="SaveChanges('不合格')" style="margin-left: unset !important">核对不通过</el-button>
                    </span>
                </el-col>
            </el-row>
            <DocFrame
                ref="doc"
                :guid="`checklist_${this.active_item.dic_operating_room_id}_${this.active_item.date}_SSJJC001`"
                :docno="this.$root.DOCUMENT && this.$root.DOCUMENT.SSJJC001"
                :surgeryId="surgeryId"
                @saved="afterDocSaved"
                :docname="docinfo.title"
                :extraParams="{ ward: this.active_item.ward, operatingroomname: this.active_item.operating_room }"
            ></DocFrame>
        </cus-dialog>

        <cus-dialog :title="copyForm.title" :visible.sync="copyForm.dialogFormVisible" width="30%" @confirm="copySave()">
            <div class="margin10 margin-none-h align-left">
                <item-input  type="date" v-model="copyForm.from_to" :noPadding="true"></item-input>
            </div>
        </cus-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SurgeryRoomSettings`,
    props: {},
    data() {
        return {
            permissions: [],
            title: `手术间检查`,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            btn_chk_result: ``,
            scheduling_date: this.$moment()
                .add(1, `days`)
                .format(`YYYY/MM/DD HH:mm:ss`), // 排程日期
            o_dic_operating_ward_id: undefined, // 排程手术区
            issetoperatingward: false,
            copyDaysConfig: this.$root.RoomSettingCopyDaysConfig || 1, // 系统设置配置的复制天数
            isOperatingRoomCheck: true,
            docinfo: { title: `手术间检查单`, docbizid: 0 },
            active_item: {
                id: 0,
                date: null,
                dic_operating_room_id: 0,
                operating_ward: ``,
                operating_room: ``,
                ward: ``,
                roomtype: ``,
                check_user: {},
                check_user_id: 0,
                check_date: new Date()
            },
            copyForm: {
                dialogFormVisible: false,
                from_to: this.$moment()
                    .add(2, `days`)
                    .format(`YYYY/MM/DD HH:mm:ss`),
                title: `手术间检查复制`
            },
            surgeryId: 0,
            dialogFormVisible: false,
            url: {
                baseURL: `/api/Preoperative/RoomSetting`,
                get: paras => {
                    return this.ReloadListData()
                },
                putMany: data => {
                    let that = this
                    // 没有应用麻醉人员权限
                    let noHaveAnesthetistPermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editWorker`) === -1
                    // 没有应用护士人员权限
                    let noHaveNursePermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editNurseWorker`) === -1

                    let reqs = data.map(d => {
                        return that.myaxios.put(`/api/Preoperative/RoomSetting/Put`, {
                            id: d.id,
                            date: d.date,
                            dic_operating_room_id: d.dic_operating_room_id,
                            dic_operating_room: {
                                id: d.dic_operating_room_id,
                                is_open: d.is_open
                            },
                            anesthetist_id: noHaveAnesthetistPermission == true ? null : (d.anesthetistObj == -2147483648 ? `` : d.anesthetistObj && d.anesthetistObj.value),
                            anesthetist_assistant_id: noHaveAnesthetistPermission == true ? null : d.anesthetist_assistantsObj && d.anesthetist_assistantsObj.map(a => a && a.value).toString(),
                            circuit_nurse_id: noHaveNursePermission == true ? null : d.circuit_nursesObj && d.circuit_nursesObj.map(a => a && a.value).toString(),
                            equipment_nurse_id: noHaveNursePermission == true ? null : d.equipment_nursesObj && d.equipment_nursesObj.map(a => a && a.value).toString(),
                            // dic_section_id: d.dic_section_id,
                            dic_section_id: d.dicSectionObj == `` ? `0` : d.dicSectionObj && d.dicSectionObj.value,
                            // surgeon_id: d.surgeon_id,
                            surgeon_id: d.surgeonObj == `` ? `0` : (d.surgeonObj && d.surgeonObj.value),
                            dic_surgery_name: d.dic_surgery_name
                        })
                    })

                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.all(...reqs)
                        req.then(res => {
                            resolve(res)
                        }).catch(e => {
                            reject(e)
                        })
                    })
                }
            },
            roomSettingWorkerConfig: this.$root.RoomSettingWorkerConfig == `1`
        }
    },
    created() {
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadPermissions()

        // 读取暂存的查询条件
        var schedulingCondition = sessionStorage.getItem(`consdrs`)
        if (schedulingCondition) {
            var obj = JSON.parse(schedulingCondition)
            this.scheduling_date = obj.scheduling_date
            this.dic_operating_ward_id = obj.dic_operating_ward_id
        }
    },
    mounted() {
        if (this.$root.DOCUMENT) {
            this.$nextTick(() => {
                this.$refs[`doc`] && this.$refs[`doc`].loadDocument()
            })
        }
    },
    beforeDestroy() {
        // 暂存查询条件
        var schedulingCondition = {
            scheduling_date: this.scheduling_date,
            dic_operating_ward_id: this.dic_operating_ward_id
        }
        sessionStorage.setItem(`consdrs`, JSON.stringify(schedulingCondition))
    },
    computed: {
        ...mapGetters([`operation_ward_auth`, `screenHeight`, `sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`, `section_auth`, `active_ward`]),
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        roomssettingWorkers() {
            return this[`sysuser/workers_by_duty`]
        },
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 160) || 0
        },
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        columnList() {
            // 没有应用麻醉人员权限
            let editWorker = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editWorker`) === -1
            // 没有应用护士人员权限
            let noHaveNursePermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editNurseWorker`) === -1
            // 排程助手按钮权限
            let intelligencePermission = this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:intelligence`) > -1
            let me = this
            let allData = me.$refs[`room_settings`] && me.$refs[`room_settings`].dataList

            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    showCol: true,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `date`,
                    label: `日期`,
                    showCol: true,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    showCol: true,
                    isKey: true
                },
                {
                    type: `bool`,
                    prop: `is_open`,
                    label: `开放状态`,
                    width: `80`,
                    readonly: false,
                    isListable: true,
                    options: `enum_bool`,
                    showCol: true,
                    default: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_wardName`,
                    label: `手术区`,
                    isListable: true,
                    width: `80`,
                    showCol: true,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `operating_room`,
                    label: `手术间`,
                    width: `80`,
                    isListable: true,
                    showCol: true,
                    sortable: false
                },
                {
                    type: `remoteselect`,
                    prop: `anesthetistObj`,
                    label: this.T(`Schedule.plan_anes_doctor`),
                    width: `80`,
                    readonly: editWorker,
                    isListable: true,
                    sortable: false,
                    showCol: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))

                            if (me.roomSettingWorkerConfig) {
                                let changeRows = me.$refs[`room_settings`] && me.$refs[`room_settings`].rowChanges
                                console.log(allData, `rowChanges`, changeRows)
                                let otherworkerIds = []
                                let changeRoomIds = changeRows && changeRows.map(d => parseInt(d.dic_operating_room_id)) || []
                                _.each(allData, d => {
                                    if (d.dic_operating_room_id != row.dic_operating_room_id) {
                                        if (changeRoomIds && changeRoomIds.length > 0 && _.includes(changeRoomIds, d.dic_operating_room_id)) {
                                            let roomrow = _.find(changeRows, { dic_operating_room_id: d.dic_operating_room_id })
                                            if (roomrow.anesthetistObj === ``) {
                                                otherworkerIds = [...otherworkerIds]
                                            } else if (roomrow.anesthetistObj && roomrow.anesthetistObj.value) {
                                                otherworkerIds.push(roomrow.anesthetistObj.value)
                                            } else if (roomrow.anesthetistObj !== `` && d.anesthetist_id) {
                                                let anesthetistId = parseInt(d.anesthetist_id)
                                                otherworkerIds.push(anesthetistId)
                                            }

                                            if (roomrow.anesthetist_assistantsObj && roomrow.anesthetist_assistantsObj.length > 0) {
                                                let anesthetistAssistantIds = roomrow.anesthetist_assistantsObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...anesthetistAssistantIds]
                                            } else if (!roomrow.anesthetist_assistantsObj && d.anesthetist_assistant_id) {
                                                otherworkerIds.push(...d.anesthetist_assistant_id)
                                            }

                                            if (roomrow.circuit_nursesObj && roomrow.circuit_nursesObj.length > 0) {
                                                let circuitNursesIds = roomrow.circuit_nursesObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...circuitNursesIds]
                                            } else if (!roomrow.circuit_nursesObj && d.circuit_nurse_id) {
                                                otherworkerIds.push(...d.circuit_nurse_id)
                                            }

                                            if (roomrow.equipment_nursesObj && roomrow.equipment_nursesObj.length > 0) {
                                                let equipmentNursesIds = roomrow.equipment_nursesObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...equipmentNursesIds]
                                            } else if (!roomrow.equipment_nursesObj && d.equipment_nurse_id) {
                                                otherworkerIds.push(...d.equipment_nurse_id)
                                            }

                                            if (roomrow.surgeonObj === ``) {
                                                otherworkerIds = [...otherworkerIds]
                                            } else if (roomrow.surgeonObj && roomrow.surgeonObj.value) {
                                                otherworkerIds.push(roomrow.surgeonObj.value)
                                            } else if (roomrow.surgeonObj !== `` && d.surgeon_id) {
                                                let surgeonId = parseInt(d.surgeon_id)
                                                otherworkerIds.push(surgeonId)
                                            }
                                        } else {
                                            if (d.workerIds && d.workerIds.length > 0) {
                                                otherworkerIds = [...otherworkerIds, ...d.workerIds]
                                            }
                                        }
                                    }
                                })
                                console.log(row.operating_room, `otherworkerIds`, otherworkerIds)
                                deepworkers = otherworkerIds && _.filter(deepworkers, d => {
                                    return !_.includes(otherworkerIds, d.value)
                                })
                            }
                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    }
                },
                {
                    type: `remotemultiselect`,
                    prop: `anesthetist_assistantsObj`,
                    label: this.T(`Schedule.plan_anes_assistants`),
                    width: `140`,
                    readonly: editWorker,
                    isListable: true,
                    sortable: false,
                    showCol: true,
                    options: (that, { row }) => { // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })
                            if (me.roomSettingWorkerConfig) {
                                let changeRows = me.$refs[`room_settings`] && me.$refs[`room_settings`].rowChanges
                                console.log(allData, `rowChanges`, changeRows)
                                let otherworkerIds = []
                                let changeRoomIds = changeRows && changeRows.map(d => parseInt(d.dic_operating_room_id)) || []
                                _.each(allData, d => {
                                    if (d.dic_operating_room_id != row.dic_operating_room_id) {
                                        if (changeRoomIds && changeRoomIds.length > 0 && _.includes(changeRoomIds, d.dic_operating_room_id)) {
                                            let roomrow = _.find(changeRows, { dic_operating_room_id: d.dic_operating_room_id })
                                            if (roomrow.anesthetistObj === ``) {
                                                otherworkerIds = [...otherworkerIds]
                                            } else if (roomrow.anesthetistObj && roomrow.anesthetistObj.value) {
                                                otherworkerIds.push(roomrow.anesthetistObj.value)
                                            } else if (roomrow.anesthetistObj !== `` && d.anesthetist_id) {
                                                let anesthetistId = parseInt(d.anesthetist_id)
                                                otherworkerIds.push(anesthetistId)
                                            }

                                            if (roomrow.anesthetist_assistantsObj && roomrow.anesthetist_assistantsObj.length > 0) {
                                                let anesthetistAssistantIds = roomrow.anesthetist_assistantsObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...anesthetistAssistantIds]
                                            } else if (!roomrow.anesthetist_assistantsObj && d.anesthetist_assistant_id) {
                                                otherworkerIds.push(...d.anesthetist_assistant_id)
                                            }

                                            if (roomrow.circuit_nursesObj && roomrow.circuit_nursesObj.length > 0) {
                                                let circuitNursesIds = roomrow.circuit_nursesObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...circuitNursesIds]
                                            } else if (!roomrow.circuit_nursesObj && d.circuit_nurse_id) {
                                                otherworkerIds.push(...d.circuit_nurse_id)
                                            }

                                            if (roomrow.equipment_nursesObj && roomrow.equipment_nursesObj.length > 0) {
                                                let equipmentNursesIds = roomrow.equipment_nursesObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...equipmentNursesIds]
                                            } else if (!roomrow.equipment_nursesObj && d.equipment_nurse_id) {
                                                otherworkerIds.push(...d.equipment_nurse_id)
                                            }

                                            if (roomrow.surgeonObj === ``) {
                                                otherworkerIds = [...otherworkerIds]
                                            } else if (roomrow.surgeonObj && roomrow.surgeonObj.value) {
                                                otherworkerIds.push(roomrow.surgeonObj.value)
                                            } else if (roomrow.surgeonObj !== `` && d.surgeon_id) {
                                                let surgeonId = parseInt(d.surgeon_id)
                                                otherworkerIds.push(surgeonId)
                                            }
                                        } else {
                                            if (d.workerIds && d.workerIds.length > 0) {
                                                otherworkerIds = [...otherworkerIds, ...d.workerIds]
                                            }
                                        }
                                    }
                                })
                                console.log(row.operating_room, `otherworkerIds`, otherworkerIds)
                                deepworkers = otherworkerIds && _.filter(deepworkers, d => {
                                    return !_.includes(otherworkerIds, d.value)
                                })
                            }

                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    config: {
                        collapseTags: true
                    }
                },
                {
                    type: `remotemultiselect`,
                    prop: `equipment_nursesObj`,
                    label: this.T(`Schedule.plan_equipment_nurse`),
                    width: `140`,
                    isListable: true,
                    showCol: true,
                    readonly: noHaveNursePermission,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))

                            if (me.roomSettingWorkerConfig) {
                                let changeRows = me.$refs[`room_settings`] && me.$refs[`room_settings`].rowChanges
                                console.log(allData, `rowChanges`, changeRows)
                                let otherworkerIds = []
                                let changeRoomIds = changeRows && changeRows.map(d => parseInt(d.dic_operating_room_id)) || []
                                _.each(allData, d => {
                                    if (d.dic_operating_room_id != row.dic_operating_room_id) {
                                        if (changeRoomIds && changeRoomIds.length > 0 && _.includes(changeRoomIds, d.dic_operating_room_id)) {
                                            let roomrow = _.find(changeRows, { dic_operating_room_id: d.dic_operating_room_id })
                                            if (roomrow.anesthetistObj === ``) {
                                                otherworkerIds = [...otherworkerIds]
                                            } else if (roomrow.anesthetistObj && roomrow.anesthetistObj.value) {
                                                otherworkerIds.push(roomrow.anesthetistObj.value)
                                            } else if (roomrow.anesthetistObj !== `` && d.anesthetist_id) {
                                                let anesthetistId = parseInt(d.anesthetist_id)
                                                otherworkerIds.push(anesthetistId)
                                            }

                                            if (roomrow.anesthetist_assistantsObj && roomrow.anesthetist_assistantsObj.length > 0) {
                                                let anesthetistAssistantIds = roomrow.anesthetist_assistantsObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...anesthetistAssistantIds]
                                            } else if (!roomrow.anesthetist_assistantsObj && d.anesthetist_assistant_id) {
                                                otherworkerIds.push(...d.anesthetist_assistant_id)
                                            }

                                            if (roomrow.circuit_nursesObj && roomrow.circuit_nursesObj.length > 0) {
                                                let circuitNursesIds = roomrow.circuit_nursesObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...circuitNursesIds]
                                            } else if (!roomrow.circuit_nursesObj && d.circuit_nurse_id) {
                                                otherworkerIds.push(...d.circuit_nurse_id)
                                            }

                                            if (roomrow.equipment_nursesObj && roomrow.equipment_nursesObj.length > 0) {
                                                let equipmentNursesIds = roomrow.equipment_nursesObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...equipmentNursesIds]
                                            } else if (!roomrow.equipment_nursesObj && d.equipment_nurse_id) {
                                                otherworkerIds.push(...d.equipment_nurse_id)
                                            }

                                            if (roomrow.surgeonObj === ``) {
                                                otherworkerIds = [...otherworkerIds]
                                            } else if (roomrow.surgeonObj && roomrow.surgeonObj.value) {
                                                otherworkerIds.push(roomrow.surgeonObj.value)
                                            } else if (roomrow.surgeonObj !== `` && d.surgeon_id) {
                                                let surgeonId = parseInt(d.surgeon_id)
                                                otherworkerIds.push(surgeonId)
                                            }
                                        } else {
                                            if (d.workerIds && d.workerIds.length > 0) {
                                                otherworkerIds = [...otherworkerIds, ...d.workerIds]
                                            }
                                        }
                                    }
                                })
                                console.log(row.operating_room, `otherworkerIds`, otherworkerIds)
                                deepworkers = otherworkerIds && _.filter(deepworkers, d => {
                                    return !_.includes(otherworkerIds, d.value)
                                })
                            }
                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    colspan: 6,
                    config: {
                        collapseTags: true
                    }
                },
                {
                    type: `remotemultiselect`,
                    prop: `circuit_nursesObj`,
                    label: this.T(`Schedule.plan_circuit_nurse`),
                    width: `140`,
                    isListable: true,
                    showCol: true,
                    readonly: noHaveNursePermission,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))

                            if (me.roomSettingWorkerConfig) {
                                let changeRows = me.$refs[`room_settings`] && me.$refs[`room_settings`].rowChanges
                                console.log(allData, `rowChanges`, changeRows)
                                let otherworkerIds = []
                                let changeRoomIds = changeRows && changeRows.map(d => parseInt(d.dic_operating_room_id)) || []
                                _.each(allData, d => {
                                    if (d.dic_operating_room_id != row.dic_operating_room_id) {
                                        if (changeRoomIds && changeRoomIds.length > 0 && _.includes(changeRoomIds, d.dic_operating_room_id)) {
                                            let roomrow = _.find(changeRows, { dic_operating_room_id: d.dic_operating_room_id })
                                            if (roomrow.anesthetistObj === ``) {
                                                otherworkerIds = [...otherworkerIds]
                                            } else if (roomrow.anesthetistObj && roomrow.anesthetistObj.value) {
                                                otherworkerIds.push(roomrow.anesthetistObj.value)
                                            } else if (roomrow.anesthetistObj !== `` && d.anesthetist_id) {
                                                let anesthetistId = parseInt(d.anesthetist_id)
                                                otherworkerIds.push(anesthetistId)
                                            }

                                            if (roomrow.anesthetist_assistantsObj && roomrow.anesthetist_assistantsObj.length > 0) {
                                                let anesthetistAssistantIds = roomrow.anesthetist_assistantsObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...anesthetistAssistantIds]
                                            } else if (!roomrow.anesthetist_assistantsObj && d.anesthetist_assistant_id) {
                                                otherworkerIds.push(...d.anesthetist_assistant_id)
                                            }

                                            if (roomrow.circuit_nursesObj && roomrow.circuit_nursesObj.length > 0) {
                                                let circuitNursesIds = roomrow.circuit_nursesObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...circuitNursesIds]
                                            } else if (!roomrow.circuit_nursesObj && d.circuit_nurse_id) {
                                                otherworkerIds.push(...d.circuit_nurse_id)
                                            }

                                            if (roomrow.equipment_nursesObj && roomrow.equipment_nursesObj.length > 0) {
                                                let equipmentNursesIds = roomrow.equipment_nursesObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...equipmentNursesIds]
                                            } else if (!roomrow.equipment_nursesObj && d.equipment_nurse_id) {
                                                otherworkerIds.push(...d.equipment_nurse_id)
                                            }

                                            if (roomrow.surgeonObj === ``) {
                                                otherworkerIds = [...otherworkerIds]
                                            } else if (roomrow.surgeonObj && roomrow.surgeonObj.value) {
                                                otherworkerIds.push(roomrow.surgeonObj.value)
                                            } else if (roomrow.surgeonObj !== `` && d.surgeon_id) {
                                                let surgeonId = parseInt(d.surgeon_id)
                                                otherworkerIds.push(surgeonId)
                                            }
                                        } else {
                                            if (d.workerIds && d.workerIds.length > 0) {
                                                otherworkerIds = [...otherworkerIds, ...d.workerIds]
                                            }
                                        }
                                    }
                                })
                                console.log(row.operating_room, `otherworkerIds`, otherworkerIds)
                                deepworkers = otherworkerIds && _.filter(deepworkers, d => {
                                    return !_.includes(otherworkerIds, d.value)
                                })
                            }
                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    colspan: 6,
                    config: {
                        collapseTags: true
                    }
                },
                {
                    type: `remoteselect`,
                    prop: `dicSectionObj`,
                    label: `分配科室`,
                    width: `140`,
                    readonly: false,
                    isListable: true,
                    sortable: false,
                    showCol: intelligencePermission,
                    options: (that, { row }) => {
                        return q => {
                            let sections = this.section_auth
                            if (q && q.keyword) {
                                return sections.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return sections
                            }
                        }
                    }
                },
                {
                    type: `remoteselect`,
                    prop: `surgeonObj`,
                    label: `分配术者`,
                    width: `140`,
                    readonly: false,
                    isListable: true,
                    sortable: false,
                    showCol: intelligencePermission,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))

                            if (me.roomSettingWorkerConfig) {
                                let changeRows = me.$refs[`room_settings`] && me.$refs[`room_settings`].rowChanges
                                console.log(allData, `rowChanges`, changeRows)
                                let otherworkerIds = []
                                let changeRoomIds = changeRows && changeRows.map(d => parseInt(d.dic_operating_room_id)) || []
                                _.each(allData, d => {
                                    if (d.dic_operating_room_id != row.dic_operating_room_id) {
                                        if (changeRoomIds && changeRoomIds.length > 0 && _.includes(changeRoomIds, d.dic_operating_room_id)) {
                                            let roomrow = _.find(changeRows, { dic_operating_room_id: d.dic_operating_room_id })
                                            if (roomrow.anesthetistObj === ``) {
                                                otherworkerIds = [...otherworkerIds]
                                            } else if (roomrow.anesthetistObj && roomrow.anesthetistObj.value) {
                                                otherworkerIds.push(roomrow.anesthetistObj.value)
                                            } else if (roomrow.anesthetistObj !== `` && d.anesthetist_id) {
                                                let anesthetistId = parseInt(d.anesthetist_id)
                                                otherworkerIds.push(anesthetistId)
                                            }

                                            if (roomrow.anesthetist_assistantsObj && roomrow.anesthetist_assistantsObj.length > 0) {
                                                let anesthetistAssistantIds = roomrow.anesthetist_assistantsObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...anesthetistAssistantIds]
                                            } else if (!roomrow.anesthetist_assistantsObj && d.anesthetist_assistant_id) {
                                                otherworkerIds.push(...d.anesthetist_assistant_id)
                                            }

                                            if (roomrow.circuit_nursesObj && roomrow.circuit_nursesObj.length > 0) {
                                                let circuitNursesIds = roomrow.circuit_nursesObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...circuitNursesIds]
                                            } else if (!roomrow.circuit_nursesObj && d.circuit_nurse_id) {
                                                otherworkerIds.push(...d.circuit_nurse_id)
                                            }

                                            if (roomrow.equipment_nursesObj && roomrow.equipment_nursesObj.length > 0) {
                                                let equipmentNursesIds = roomrow.equipment_nursesObj.map(d => parseInt(d.value))
                                                otherworkerIds = [...otherworkerIds, ...equipmentNursesIds]
                                            } else if (!roomrow.equipment_nursesObj && d.equipment_nurse_id) {
                                                otherworkerIds.push(...d.equipment_nurse_id)
                                            }

                                            if (roomrow.surgeonObj === ``) {
                                                otherworkerIds = [...otherworkerIds]
                                            } else if (roomrow.surgeonObj && roomrow.surgeonObj.value) {
                                                otherworkerIds.push(roomrow.surgeonObj.value)
                                            } else if (roomrow.surgeonObj !== `` && d.surgeon_id) {
                                                let surgeonId = parseInt(d.surgeon_id)
                                                otherworkerIds.push(surgeonId)
                                            }
                                        } else {
                                            if (d.workerIds && d.workerIds.length > 0) {
                                                otherworkerIds = [...otherworkerIds, ...d.workerIds]
                                            }
                                        }
                                    }
                                })
                                console.log(row.operating_room, `otherworkerIds`, otherworkerIds)
                                deepworkers = otherworkerIds && _.filter(deepworkers, d => {
                                    return !_.includes(otherworkerIds, d.value)
                                })
                            }
                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `dic_surgery_name`,
                    label: `分配术式`,
                    isListable: true,
                    width: `140`,
                    sortable: false,
                    showCol: intelligencePermission,
                    readonly: false
                },
                {
                    type: `string`,
                    prop: `room_type`,
                    label: `手术间类型`,
                    // width: `140`,
                    isListable: true,
                    isExpand: false,
                    showCol: true,
                    sortable: false
                }
            ] // 列表列
            let oper = [
                {
                    type: `string`,
                    prop: `check_result`,
                    label: `检查结果`,
                    width: `140`,
                    isListable: true,
                    isExpand: false,
                    showCol: true,
                    sortable: false
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `100`,
                    fixed: `right`,
                    isListable: true,
                    readonly: false,
                    showCol: true,
                    options: [
                        {
                            class: `is-plain`,
                            label: `检查单`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadCheckList`,
                            permission: `default`
                        }
                    ]
                }
            ]

            let cols = _.filter(list, col => {
                return col.showCol == true
            })
            if (this.$root.IsOperatingRoomCheck == `true`) {
                return cols.concat(oper)
            } else {
                return cols
            }
        }
    },
    methods: {
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {
                console.log(e)
            })
        },
        ReloadListData() {
            // 更改日期触发更新列表
            let that = this
            return new Promise(resolve => {
                let req = that.myaxios.get(`/api/Preoperative/RoomSetting/Get`, { date: that.scheduling_date })
                let now = new Date()
                req.then(data => {
                    console.log(`RoomSetting`, data)
                    if (that.dic_operating_ward_id) {
                        data = _.filter(data, { dic_operating_ward_id: that.dic_operating_ward_id })
                    }
                    let r = data.map(d => {
                        return {
                            id: d.id,
                            date: that.scheduling_date,
                            dic_operating_room_id: d.dic_operating_room_id,
                            dic_operating_ward_id: d.dic_operating_ward_id,
                            dic_operating_wardName: d.dic_operating_wardName,
                            is_open: d.dic_operating_room.is_open,
                            operating_room: d.dic_operating_room.name,
                            anesthetist_id: d.anesthetist_id,
                            anesthetistObj: d.anesthetistObj,
                            anesthetist_assistant_id: d.anesthetist_assistant_id && d.anesthetist_assistant_id.split(`,`).map(d => parseInt(d)),
                            // 上面anesthetist_assistant_id 字段弃用，改用下面这个字段
                            anesthetist_assistantsObj: d.anesthetist_assistantsObj,
                            circuit_nurse_id: d.circuit_nurse_id && d.circuit_nurse_id.split(`,`).map(d => parseInt(d)),
                            // 上面circuit_nurse_id 字段弃用，改用下面这个字段
                            circuit_nursesObj: d.circuit_nursesObj,
                            equipment_nurse_id: d.equipment_nurse_id && d.equipment_nurse_id.split(`,`).map(d => parseInt(d)),
                            // 上面equipment_nurse_id 字段弃用，改用下面这个字段
                            equipment_nursesObj: d.equipment_nursesObj,
                            dic_section_id: d.dic_section_id,
                            dicSectionObj: d.dicSectionObj,
                            surgeon_id: d.surgeon_id,
                            surgeonObj: d.surgeonObj,
                            special_device: d.dic_operating_room.special_device,
                            room_type: d.dic_operating_room.room_type,
                            clean_level: d.dic_operating_room.clean_level,
                            temperature: d.dic_operating_room.temperature,
                            humidity: d.dic_operating_room.humidity,
                            clean_period: d.dic_operating_room.clean_period,
                            isolation: d.dic_operating_room.isolation,
                            dic_surgery_name: d.dic_surgery_name,
                            check_result: d.check_result,
                            check_date: d.check_date == null ? this.$moment(now).format(`YYYY/MM/DD HH:mm:ss`) : this.$moment(d.check_date).format(`YYYY/MM/DD HH:mm:ss`),
                            check_user_id: d.check_user_id,
                            check_user: d.check_user,
                            workerIds: d.workerIds
                        }
                    })
                    console.log(`data`, r)
                    resolve(r)
                }).catch(e => {
                    resolve([])
                })
            })
        },
        // added by xiaorui,
        // 日期：2021-08-18
        // 功能：复制功能
        copy() {
            let that = this
            that.copyForm.dialogFormVisible = true
        },
        copySave() {
            let that = this
            let d = this.$moment(this.scheduling_date)
            let schedulingDate = `${d.format(`MM月DD日`)}`
            console.log(this.copyForm)
            let f = this.$moment(that.copyForm.from_to)
            // let copyDays = that.copyDaysConfig
            let copyDaysStr = f.format(`MM月DD日`)

            this.$confirm(`是否将${schedulingDate}的手术间设置复制到${copyDaysStr}?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.get(`/api/Preoperative/RoomSetting/Copy`, { date: that.scheduling_date, datenew: that.copyForm.from_to })
                req.then(data => {
                    this.$message({
                        type: `success`,
                        message: `复制成功!`
                    })
                    that.copyForm.dialogFormVisible = false
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        // added by xiaorui,
        // 日期：2022-02-10
        // 功能：把安排的手术人员同步到已排程未手术的手术上
        syncWorkerToScheduledSurgery() {
            let that = this
            that.$confirm(`此排班安排人员会替换所有已排程手术人员<br/>选择【是】替换，【否】保留以前人员，【X】取消`, `提示`, {
                confirmButtonText: `是`,
                cancelButtonText: `否`,
                distinguishCancelAndClose: true,
                dangerouslyUseHTMLString: true,
                closeOnClickModal: false
            }).then(() => {
                let req = that.myaxios.get(`/api/Preoperative/RoomSetting/SyncWorkerToScheduledSurgery`, { date: that.scheduling_date, isReplace: true })
                req.then(data => {
                    that.$message({
                        type: `success`,
                        message: `已成功配置人员到排程手术中!`
                    })
                }).catch(e => {
                    console.log(e)
                })
            }).catch((action) => {
                if (action === `cancel`) {
                    let req = that.myaxios.get(`/api/Preoperative/RoomSetting/SyncWorkerToScheduledSurgery`, { date: that.scheduling_date, isReplace: false })
                    req.then(data => {
                        that.$message({
                            type: `success`,
                            message: `已成功配置人员到排程手术中!`
                        })
                    }).catch(e => {
                        console.log(e)
                    })
                }
            })
        },
        loadCheckList({ row }) {
            let ward = _.find(this.operation_ward_auth, { value: row.dic_operating_ward_id })
            this.active_item.id = row.id
            this.active_item.date = this.$moment(row.date).format(`YYYY-MM-DD`)
            this.active_item.dic_operating_room_id = row.dic_operating_room_id
            this.active_item.ward = ward && ward.label
            this.active_item.operating_room = row.operating_room
            this.active_item.roomtype = row.room_type
            this.active_item.check_user = row.check_user
            this.active_item.check_user_id = row.check_user_id
            this.active_item.check_date = row.check_date
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs.doc && this.$refs.doc.loadDocument()
            })
        },
        afterDocSaved() {
            let req = this.myaxios.put(`/api/Preoperative/RoomSetting/Put`, {
                id: this.active_item.id,
                date: this.active_item.date,
                dic_operating_room_id: this.active_item.dic_operating_room_id,
                check_user_id: this.active_item.check_user_id,
                check_date: this.active_item.check_date,
                check_result: this.btn_chk_result
            })

            req.then(data => {
                this.$refs[`room_settings`].ReloadListData()
                this.dialogFormVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        SaveChanges(result) {
            let valid = true
            this.btn_chk_result = result
            if (valid) {
                this.$refs.doc.save()
            }
        },
        changed() {}
    },
    watch: {
        scheduling_date: function() {
            // 更改日期触发更新列表
            this.$refs[`room_settings`].ReloadListData()
        },
        dic_operating_ward_id: function() {
            this.$refs[`room_settings`].ReloadListData()
        }
    }
}
</script>
<style scoped>
.dialog-adverse .el-dialog__body {
    padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/SurgeryRoomSettings.vue